const SEARCH_ROUTES = {
  news: { path: '/news', useVuex: false },
  photos: { path: '/search_pic', useVuex: true },
  videos: { path: '/topic_video', useVuex: false },
  vr: { path: '/fvr', useVuex: false },
};

/**
 * 新首页搜索：按分类跳转到对应模块页并携带关键词
 * @returns {boolean} 是否已发起跳转
 */
export function navigateNewIndexSearch(router, store, { query, category = 'news' }) {
  const keyword = (query || '').trim();
  if (!keyword) return false;

  const routeConfig = SEARCH_ROUTES[category] || SEARCH_ROUTES.news;

  if (routeConfig.useVuex) {
    store.dispatch('common/searchKeywords', {
      keyword,
      from: 'other',
      type: 'keyword',
    });
    router.push({ path: routeConfig.path });
    return true;
  }

  router.push({
    path: routeConfig.path,
    query: { keyword },
  });
  return true;
}
